import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import theme from "styles/theme";
import { merge, $ } from "glamor";
import Globalize from "globalize";
import classNames from "classnames";
import { decodeHtml } from "../../utils/utilities";
import { ItemCellSize } from "constants/types";
import { DATATEST } from "constants/integration";
const styles = merge(
    $(" .price", {
        color: theme.palette.darkGrey,
        fontSize: "12px",
        letterSpacing: "0.2px",
        lineHeight: "16px",
        marginTop: "0px",
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
    }),
    $(".small .price", {
        color: theme.palette.darkGrey,
        fontSize: "12px",
        letterSpacing: "0.2px",
        marginTop: "0px",
        width: "100%",
    }),
    $(".large-tile .price.retail", {
        opacity: 0.7,
    }),
    $(" .price > label", {
        display: "inline-block",
        marginRight: "7px",
    }),
    $(".small .price > label", {
        marginRight: "4px",
    }),
    $(" .description", {
        margin: "0px",
        color: theme.palette.darkerGrey,
        maxWidth: "100%",
        padding: "0px",
        lineHeight: "1.67",
        height: "20px",
        fontSize: "12px",
        letterSpacing: "0.2px",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        display: "flex",
    }),
    $(" .msrpLabel", {
        fontSize: "10px",
    }),
    $(" .msrpLabel.large-tile", {
        marginLeft: "5px",
        fontSize: "14px",
    }),
    $(".small .msrpLabel", {
        paddingLeft: "0px",
    }),
    $(".small .description", {
        lineHeight: "12px",
        fontSize: "12px",
        height: "16px",
    }),
    $(" .importantDescription", {
        color: theme.palette.darkerGrey,
        fontWeight: "bold",
        lineHeight: "20px",
        letterSpacing: "0.2px",
        fontSize: "14px",
        margin: "0px",
        display: "-webkit-box",
        height: "40px",
        WebkitLineClamp: 2,
        WebkitBoxOrient: "vertical",
        overflow: "hidden",
        textOverflow: "ellipsis",
        maxWidth: "100%",
    }),
    $(".small .importantDescription", {
        lineHeight: "15px",
        WebkitLineClamp: 2,
        letterSpacing: "0.1px",
        fontSize: "12px",
        height: "32px",
        marginBottom: "2px",
    }),
    $(".large-tile .importantDescription", {
        lineHeight: "18px",
        WebkitLineClamp: 2,
        letterSpacing: "0.1px",
        fontSize: "16px",
        height: "35px",
        margin: "10px 0",
    }),
    $(".collection .importantDescription", {
        overflow: "hidden",
        textOverflow: "ellipsis",
    }),
    $(" .placeholderHeader", {
        height: "16px",
        margin: "12px 0px 32px",
        background: theme.palette.lightestGrey,
    }),
    $(" .placeholderSecond", {
        background: theme.palette.lightestGrey,
        height: "14px",
    }),
    $(" .placeholderPrice", {
        background: theme.palette.lightestGrey,
        height: "14px",
        width: "40px",
        margin: "8px 0 0",
    }),
    $(" .pricingFields", {
        position: "absolute",
    }),
    $(" .collection .pricingFields", {
        bottom: "0px",
    }),
    $(".small .pricingFields", {
        bottom: "22px",
        marginTop: "0px",
        height: "64px",
        display: "table-cell",
        verticalAlign: "bottom",
        position: "inherit",
    }),
    $(".small.tile .pricingFields", {
        bottom: "22px",
        height: "40px",
        maxWidth: "76px",
    }),
    $(".large-tile .pricingFields", {
        bottom: "60px",
        height: "40px",
    }),
    $(" .small .placeholderPrice", {
        height: "64px",
    }),
    $(" .elementLabel", {
        width: "54px",
        overflow: "hidden",
        textOverflow: "ellipsis",
        fontSize: "10px",
        lineHeight: "2.0",
        display: "inline-block",
        marginRight: "6px",
    }),
    $(".large-tile .elementLabel", {
        width: "74px",
    }),
    $(" .elementValue", {
        display: "inline-block",
        minWidth: "102px",
        overflow: "hidden",
        textOverflow: "ellipsis",
    }),
    $(" .small.elementValue", {
        fontSize: "11px",
    }),
    $(" .priceValue", {
        fontWeight: "bold",
        fontSize: "11px",
        minHeight: "16px",
        width: "70px",
    }),
    $(".large-tile .priceValue", {
        fontWeight: "bold",
        fontSize: "14px",
        minHeight: "23px",
        width: "100%",
        whiteSpace: "nowrap",
    }),
    $(" .collection .priceValue", {
        width: "75px",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
    }),
    $(".small.card .strikethrough", {
        textDecoration: "line-through",
        fontWeight: "500",
        width: "100%",
        paddingLeft: "45%",
    }),
    $(".small.tile .strikethrough", {
        textDecoration: "line-through",
        fontWeight: "500",
    }),
    $(".big .strikethrough", {
        textDecoration: "line-through",
        fontWeight: "500",
        width: "100%",
        paddingLeft: "45%",
    }),
    $(".large-tile .strikethrough", {
        textDecoration: "line-through",
        fontWeight: "500",
    }),
);

/** @augments {PureComponent<any, any>} */
class ItemBody extends PureComponent {
    static contextTypes = {
        me: PropTypes.object.isRequired,
    };

    render() {
        const { me } = this.context;
        const {
            lines = 5,
            showPrice = true,
            item,
            shipStart,
            view,
            small = false,
            style,
            hideMSRP = false,
            size = "",
            scope,
        } = this.props;
        const enableStrikethrough = scope.brand.isStrikethroughEnabled(scope);
        const showWholesale = showPrice && !scope.hideWholesale;
        const showMsrp = !hideMSRP && !scope.hideMsrp;
        const descriptionFields = [];
        const pricingFields = [];

        if (view && item) {
            const details = view.sections.get("details");
            if (details) {
                details.elements.reduce((acc, element, i) => {
                    if (i >= lines) {
                        return acc;
                    }

                    const value = element.getValue(item);

                    if (value) {
                        if (i === 0) {
                            acc.push(
                                <h1 key={element.reference + "-value" + i} className="importantDescription">
                                    {decodeHtml(value)}
                                </h1>,
                            );
                        } else {
                            if (size === ItemCellSize.Card) {
                                acc.push(
                                    <div
                                        key={element.reference + "-value" + i}
                                        className="description"
                                        data-test={element.reference}
                                    >
                                        <div
                                            className={classNames({
                                                small: small ? "small" : undefined,
                                                [size]: size,
                                                elementValue: true,
                                            })}
                                        >
                                            {element.label} {decodeHtml(value)}
                                        </div>
                                    </div>,
                                );
                            } else {
                                acc.push(
                                    <div
                                        key={element.reference + "-value" + i}
                                        className="description"
                                        data-test={element.reference}
                                    >
                                        {!!element.label && (
                                            <div
                                                className={classNames("elementLabel", {
                                                    [size]: size,
                                                })}
                                            >
                                                {element.label}
                                            </div>
                                        )}
                                        <div
                                            className={classNames({
                                                small: small ? "small" : undefined,
                                                [size]: size,
                                                elementValue: true,
                                            })}
                                        >
                                            {decodeHtml(value)}
                                        </div>
                                    </div>,
                                );
                            }
                        }
                    }
                    return acc;
                }, descriptionFields);
            }

            const msrpCurrency = me.isGuestBuyer() ? scope.brand.settings.default_currency : me._activeMSRPCurrency;
            const { minOriginalWholesale, originalWholesale, minAdjustedWholesale, adjustedWholesale, msrp } =
                item.getFormattedPrices(me._activeCurrency, { msrpCurrency, date: shipStart }, scope);

            if (showWholesale && view.sections.get("pricing")) {
                let priceLabel;
                if (size === ItemCellSize.Big || size === ItemCellSize.Card || size === ItemCellSize.Collection) {
                    priceLabel = <label className="msrpLabel">{Globalize.formatMessage("Wholesale")}:</label>;
                }

                if (enableStrikethrough && originalWholesale && minOriginalWholesale > minAdjustedWholesale) {
                    pricingFields.push(
                        <div key="price-before-discount" className="price wholesale">
                            <span
                                className="priceValue strikethrough"
                                data-test={DATATEST.PRODUCT.PRICES.ORIGINAL_WHOLESALE}
                            >
                                {originalWholesale}
                            </span>
                        </div>,
                    );
                }

                pricingFields.push(
                    <div key="price" className="price wholesale">
                        {priceLabel}
                        <span className="priceValue" data-test={DATATEST.PRODUCT.PRICES.WHOLESALE}>
                            {adjustedWholesale || "--"}
                        </span>
                    </div>,
                );
            }

            if (showMsrp && view.sections.get("msrp") && msrp) {
                pricingFields.push(
                    <div key="msrp" className="price retail">
                        {size !== ItemCellSize.LargeTile && (
                            <label className="msrpLabel">{Globalize.formatMessage("MSRP")}:</label>
                        )}
                        <span className="priceValue retail" data-test={DATATEST.PRODUCT.PRICES.MSRP}>
                            {msrp}
                        </span>
                        {size === ItemCellSize.LargeTile && (
                            <label className={`msrpLabel ${size}`}>{Globalize.formatMessage("MSRP")}</label>
                        )}
                    </div>,
                );
            }
        } else {
            // place holder till we get the view back
            descriptionFields.push(<h1 key="h1" className="placeholderHeader" />);
            if (lines > 1) {
                descriptionFields.push(<div key="second" className="placeholderSecond" />);
            }
            if (showPrice) {
                descriptionFields.push(<div key="price" className="placeholderPrice" />);
            }
        }

        return (
            <div
                {...styles}
                style={style}
                className={classNames({
                    small: small ? "small" : undefined,
                    [size]: size,
                })}
            >
                {descriptionFields}

                {pricingFields.length > 0 && (
                    <div className={classNames("pricingFields", { collection: size === ItemCellSize.Collection })}>
                        {pricingFields}
                    </div>
                )}
            </div>
        );
    }
}

export default ItemBody;
